import Vue from "vue";
import Router from "vue-router";
import store from "../store/index";
import {
  getToken
} from '@/utils/auth' // getToken from cookie

// import {
//   Toast
// } from 'vant';


const whiteList = ['/login', '/articledetail','/usercard','/unsign','/pdf','/video','/demo','/pdf2'] // no redirect whitelist

Vue.use(Router);
const router = new Router({
  routes: [{
      path: "/",
      redirect: "/login"
    },
    {
      name: 'newindex',
      path: "/newindex",
      component: () => import("@/views/newIndex/index"),
      meta: {
        title: "首页",
        // 缓存首页
        keepAlive: false
      }
    },
    {
      name: 'index',
      path: "/index",
      component: () => import("@/views/index/index"),
      meta: {
        title: "学院首页",
        // 缓存首页
        keepAlive: true
      }
    },
    {
      path: "/my",
      component: () => import("@/views/my/index"),
      meta: {
        title: "我的",

        // 缓存首页
        keepAlive: false
        // 缓存首页
      }
    },
    {
      path: "/myinfo",
      component: () => import("@/views/my/myInfo"),
      meta: {
        title: "个人资料"
      }
    },
    {
      path: "/mycourse",
      component: () => import("@/views/my/myCourse"),
      meta: {
        title: "我的课程"
      }
    },
    {
      path: "/myteam",
      component: () => import("@/views/my/myTeam"),
      meta: {
        title: "我的团队"
      }
    },
    {
      name: 'login',
      path: '/login',
      component: () => import("@/views/login/index"),
      meta: {
        title: '登录'
      }
    },
    {
      name: 'courseList',
      path: '/courseList',
      component: () => import("@/views/courseList/index"),
      meta: {
        title: '培训课程',
        keepAlive: true
      }
    },
    ,
    {
      name: 'courseList1',
      path: '/courseList1',
      component: () => import("@/views/courseType/list"),
      meta: {
        title: '培训课程',
        keepAlive: true
      }
    },
    {
      name: 'courseDetail',
      path: '/courseDetail',
      component: () => import("@/views/courseDetail/index"),
      meta: {
        title: '课程详情'
      }
    },
    {
      name: 'classDetail',
      path: '/classDetail',
      component: () => import("@/views/classDetail/index"),
      meta: {
        title: '课时详情'
      }
    },
    {
      name: 'prolist',
      path: '/prolist',
      component: () => import("@/views/produceList/index"),
      meta: {
        title: '产品列表'
      }
    },
    // {
    //   name: 'bllist',
    //   path: '/bllist',
    //   component: () => import("@/views/produceList/blprodlist"),
    //   meta: {
    //     title: '保险商城'
    //   }
    // },
    // // 宾理搜索页
    // {
    //   name: 'blsearch',
    //   path: '/blsearch',
    //   component: () => import("@/views/produceList/blsearch"),
    //   meta: {
    //     title: '保险商城'
    //   }
    // },
    {
      name: 'myorders',
      path: '/myorders',
      component: () => import("@/views/produceList/myOrders"),
      meta: {
        title: '我的订单'
      }
    },
    // 新页面
    {
      name: 'allprod',
      path: '/allprod',
      component: () => import("@/views/allProduce/index"),
      meta: {
        title: '产品库',
      }
    },
    {
      name: 'prodetail',
      path: '/prodetail',
      component: () => import("@/views/allProduce/detail"),
      meta: {
        title: '产品详情'
      }
    },
    {
      name: 'card',
      path: '/card',
      component: () => import("@/views/card/businessCard"),
      meta: {
        title: '设置名片'
      }
    },
    {
      name: 'usercard',
      path: '/usercard',
      component: () => import("@/views/card/usercard"),
      meta: {
        title: '我的名片'
      }
    },
    {
      name: 'article',
      path: '/article',
      component: () => import("@/views/article/index"),
      meta: {
        title: '获客爆文'
      }
    },
    {
      name: 'articledetail',
      path: '/articledetail',
      component: () => import("@/views/article/detail"),
      meta: {
        title: '文章详情'
      }
    },
    {
      name: 'poster',
      path: '/poster',
      component: () => import("@/views/poster/index"),
      meta: {
        title: '海报'
      }
    },
    {
      name: 'postersetting',
      path: '/postersetting',
      component: () => import("@/views/poster/setting"),
      meta: {
        title: '海报详情'
      }
    },
    {
      name: 'myclients',
      path: '/myclients',
      component: () => import("@/views/myclients/index"),
      meta: {
        title: '我的客户'
      }
    },
    {
      name: 'clientdetail',
      path: '/clientdetail',
      component: () => import("@/views/myclients/detail"),
      meta: {
        title: '客户详情'
      }
    },
    {
      name: 'search',
      path: '/search',
      component: () => import("@/views/poster/search"),
      meta: {
        title: '搜索'
      }
    },
    // 告知书相关页面
    {
      name: 'notice',
      path: '/notice',
      component: () => import("@/views/notification/index"),
      meta: {
        title: '我的告知书',
        keepAlive:true
      }
    },
    // 创建告知书
    {
      name: 'createnotice',
      path: '/createnotice',
      component: () => import("@/views/notification/create"),
      meta: {
        title: '创建告知书',
        keepAlive:true
      }
    },
    // 未签名
    {
      name: 'unsign',
      path: '/unsign',
      component: () => import("@/views/notification/unsign"),
      meta: {
        title: '客户告知书'
      }
    },
    //公司 产品搜索 noticesearch
    {
      name: 'noticesearch',
      path: '/noticesearch',
      component: () => import("@/views/notification/noticesearch"),
      meta: {
        title: '选择产品'
      }
    },
    {
      name: 'avater',
      path: '/avater',
      component: () => import("@/views/card/avater"),
      meta: {
        title: '头像设置'
      }
    },
    {
      name: 'pdf',
      path: '/pdf',
      component: () => import("@/views/file/pdf"),
      meta: {
        title: 'pdf'
      }
    },
    {
      name: 'pdf2',
      path: '/pdf2',
      component: () => import("@/views/file/pdf2"),
      meta: {
        title: '预览pdf文件'
      }
    },
    {
      name: 'video',
      path: '/video',
      component: () => import("@/views/file/video"),
      meta: {
        title: 'video'
      }
    },
    // 老师列表
    {
      name: 'tealist',
      path: '/tealist',
      component: () => import("@/views/teachers/list"),
      meta: {
        title: '讲师列表'
      }
    },
    //讲师主页
    {
      name: 'teadetail',
      path: '/teadetail',
      component: () => import("@/views/teachers/detail"),
      meta: {
        title: '讲师主页'
      }
    },
    // demo
    {
      name: 'demo',
      path: '/demo',
      component: () => import("@/views/file/demo"),
      meta: {
        title: '讲师主页'
      }
    },
    //  我的收藏
    {
      name: 'collection',
      path: '/collection',
      component: () => import("@/views/my/myCollection"),
      meta: {
        title: '我的收藏'
      }
    },
    //课程分类
    {
      name: 'coursetype',
      path: '/coursetype',
      component: () => import("@/views/courseType/index"),
      meta: {
        title: '课程分类'
      }
    },
    //我的关注
    {
      name: 'myfocus',
      path: '/myfocus',
      component: () => import("@/views/my/myFocus"),
      meta: {
        title: '我的关注'
      }
    },
    {
      path: "/401",
      component: () => import("@/components/401"),
      meta: {
        title: '未授权'
      }
    },
    {
      path: "*",
      component: () => import("@/components/404"),
      meta: {
        title: '未知页面'
      }
    }
  ]
});

//导航守卫，发现问题就让页面跳转到其他地方
router.beforeEach((to, from, next) => {
  if (from.path == '/classDetail') {
    sessionStorage.setItem('beforepath', 1)
  } else {
    sessionStorage.removeItem("beforepath")
  }
  if (to.meta.title) {
    document.title = to.meta.title //+ ' - ' + Config.title
  }
  let url=sessionStorage.getItem("url")
  if (to.path != '/login' && to.path != '/'&&to.path!='/pdf'&&to.path!='/video') {
    sessionStorage.setItem('url', to.fullPath)
  }else if(getToken()&&url==from.fullPath){
    sessionStorage.removeItem('url')
  }
  if (getToken()) {

      next()

  } else {
    // 未登录
    if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
      next()
    } else {
      next('/login')
    }
  }
})


router.afterEach((to) => {

})
export default router;